<template>
  <div>
    <h2>Alerts for suspicious traffic</h2>
    <p>
      Configure your alerts to track suspicious traffic seen coming from your
      network.
    </p>
    <img
      src="../../assets/exclamation-icon.svg"
      class="icon"
      alt="exclamation"
    />
    <div v-if="isWithSelectedASN">
      <p>You do not have alerts yet for the selected origin AS.</p>
      <button
        class="btn btn-primary"
        @click="showCreateAlertModal"
        :disabled="!isWithSelectedASN"
      >
        Create alert
      </button>
    </div>
    <p v-else>
      To create an alert, there must be an ASN associated with the selected
      member account.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MobileSortTool from '../alerts/overview/alertTableParts/MobileSortTool';
import MobileAlertCard from '../alerts/overview/alertTableParts/MobileAlertCard.vue';

export default {
  name: 'WithoutAlertRule',
  components: { MobileSortTool, MobileAlertCard },
  computed: {
    ...mapGetters('dataStore', ['selectedASN']),

    isWithSelectedASN() {
      if (this.selectedASN && this.selectedASN.id) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    showCreateAlertModal() {
      this.$emit('showCreateAlertModal');
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
button {
  margin-top: 2rem;
}
</style>
